import React from 'react';

export type ParticleCellProps = {
  name: string;
  enabled: boolean;
  contentsRect: {x: number; y: number; width: number; height: number}; // Always the same
  magnificationFilter: 'linear' | 'nearest'; // Unused
  minificationFilter: 'linear' | 'nearest'; // Unused
  minificationFilterBias: number; // Unused
  color: any; // Use appropriate type
  redRange: number; // Supported
  greenRange: number; // Supported
  blueRange: number; // Supported
  alphaRange: number; // Supported
  redSpeed: number; // Supported
  greenSpeed: number; // Supported
  blueSpeed: number; // Supported
  alphaSpeed: number; // Supported
  lifetime: number; // Supported
  lifetimeRange: number; // Supported
  birthRate: number; // Supported
  scale: number; // not yet implemented
  scaleRange: number; // not yet implemented
  scaleSpeed: number; // not yet implemented
  velocity: number; // Supported
  velocityRange: number; // Supported
  xAcceleration: number; // Supported
  yAcceleration: number; // Supported
  zAcceleration: number; // not yet implemented
  spin: number; // Supported
  spinRange: number; // Supported
  emissionLatitude: number; // Supported
  emissionLongitude: number; // Supported
  emissionRange: number; // Supported
  beginTime: number; // not implemented
  duration: number; // not implemented
  timeOffset: number; // not implemented
  repeatCount: number; // not implemented
  repeatDuration: number; // not implemented
  autoreverses: boolean; // not implemented
  fillMode: 'backwards' | 'forwards' | 'both' | 'removed'; // not implemented
  children?: React.ReactNode;
};

const ParticleCell = (props: ParticleCellProps) => {
  // TODO: implement Particle System for Web: https://skillzinc.atlassian.net/browse/RP-701
  console.log('WebSDK: ParticleCell MOCK USED');

  // The mock implementation should pass children properly
  return <div>{props.children}</div>;
};

export default ParticleCell;
